import React from 'react';

import {withParamsFrame} from "../HOCs";
import {IframePage} from "../types/iframe";

const StartPage: React.FC<IframePage> = ({ params }) => {
    const [httpParams] = React.useState(params);

    return (
        <div className='xs:mx-3'>
            <div>
                <iframe className={'page-iframe'} src={`https://lk.market/start${httpParams}`}
                    title="StartPage"
                    width="100%"
                    height={"calc(100vh-64px)"}
                ></iframe>
            </div>
        </div>
    );
}

export default withParamsFrame(StartPage);